import React, { useState } from "react";
import Select from "react-select";
import selectStyle from "../../../design/selectStyle";
import { useTranslation } from "react-i18next";
import AddEditPaymentBankAccount from "./AddEditPaymentBankAccount";
import { Dialog } from "primereact/dialog";
import mainAxios from "../../../services/mainAxios";
import { useAppContext } from "../../../AppContext";
import { toast } from 'react-toastify'
import AddBankAccount from "../../Companies/BankAccounts/AddBankAccount";
import TooltipOverlay from "../../global/TooltipOverlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";


const PaymentBankAccounts = ({ payment, refreshData, handleChange }) => {
    const { t } = useTranslation("translations");
    const [addBankAccountVisible, setAddBankAccountVisible] = useState({ show: false, id: null, type: null })
    const { user: [user], selectedCompany: [selectedCompany], company: [fullCompany] } = useAppContext()

    const addEditSellerAccount = (state) => {
        mainAxios.post("/endpoint/v2/purchase/invoice/bank/account", {
            content: {
                ...state,
                bank: {
                    id: state?.bank?.id
                },
                purchaseInvoiceExtracted: {
                    id: payment?.purchaseInvoice?.purchaseInvoiceExtracted?.id
                }
            },
            nuis: user.companiesRights.find(
                (company) => company.id === parseInt(selectedCompany)
            )?.nuis,
        })
            .then(res => {
                if (res.data.status) {
                    toast.success(addBankAccountVisible?.id ? t("toast.editBankAccount") : t(["toast.addBankAccount"]), {
                        containerId: "all_toast",
                    });
                    setAddBankAccountVisible({ show: false, id: null, type: null })
                    refreshData()
                }
            })

    }

    const bankAccountModal = (
        <>
            <Dialog
                header={
                    addBankAccountVisible.id ? t("bankAccount.edit") : t("bankAccount.add")
                }
                visible={addBankAccountVisible.show}
                onHide={() =>
                    setAddBankAccountVisible((state) => ({ ...state, show: false }))
                }
                style={{ width: "30vw", minHeight: "50vh" }}
                breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                closable={true}
                dismissableMask={true}
            >
                {addBankAccountVisible.show == true && addBankAccountVisible.type == "seller" && (
                    <AddEditPaymentBankAccount
                        type={addBankAccountVisible.type}
                        state={addBankAccountVisible.id?payment.sellerBankAccount:null}
                        onSave={(state) => {
                            addEditSellerAccount(state)
                        }}
                    />
                )}
                {addBankAccountVisible.show == true && addBankAccountVisible.type == "buyer" && <AddBankAccount
                    company={fullCompany}
                    bankAccountId={addBankAccountVisible.id}
                    onBankAdded={() => {
                        setAddBankAccountVisible({ show: false, id: null })
                        refreshData()

                    }}
                />}
            </Dialog>
        </>
    );

    return (
        <>
            {bankAccountModal}
            <div className="card-body">
                <div className="row justify-content-center">
                    <div className="col-6 col-md-5">
                        <div className="form-group">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                                <div className="d-flex align-items-center">

                                <label htmlFor="buyerBankAccounts" style={{ fontSize: 18, fontWeight: 600,margin:0 }}>
                                    Buyer Bank Account
                                </label>
                                {payment?.buyerBankAccount?.id && <TooltipOverlay title={t("common.edit")} show={0} hide={0}>
                                    <div
                                        onClick={() => {
                                            const accountId =payment?.buyerBankAccount?.id
                                            setAddBankAccountVisible({ show: true, id: accountId?accountId.toString():null , type: "buyer" })
                                        }
                                        }
                                        className="nav-link p-0 ml-3"
                                        style={{cursor:"pointer"}}
                                    >
                                        <FontAwesomeIcon icon={faEdit} className="mr-1" />
                                    </div>
                                </TooltipOverlay>
                                }
                                </div>
                                <button
                                    className="btn btn-sm btn-outline-primary justify-content-center align-items-center mb-0"
                                    onClick={() => setAddBankAccountVisible({ show: true, id: null, type: "buyer" })}
                                >
                                    {t("item.add")}
                                </button>
                            </div>
                            <Select
                                // options={payment?.buyerBankAccounts ?? []}
                                options={payment?.buyerBankAccounts?.filter(bankAccount => bankAccount?.bank?.paymentsEnabled != null) ?? []}
                                getOptionLabel={option => option?.bankName}
                                getOptionValue={option => option?.id}
                                styles={selectStyle}
                                value={payment?.buyerBankAccount}
                                onChange={(bankAccount) => {
                                    handleChange(
                                        null,
                                        "buyerBankAccount",
                                        bankAccount
                                    );
                                }}
                            />
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label htmlFor="iban">
                                        IBAN
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={payment?.buyerBankAccount?.iban}
                                        onChange={() => { }}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label htmlFor="bankName">
                                        Bank Name
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={payment?.buyerBankAccount?.bank?.name}
                                        onChange={() => { }}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label htmlFor="bankAccount">
                                        Bank Account
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={payment?.buyerBankAccount?.bankName}
                                        onChange={() => { }}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label htmlFor="bankAccountNumber">
                                        Bank Account Number
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={payment?.buyerBankAccount?.bankAccountNumber}
                                        onChange={() => { }}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label htmlFor="recordDate">
                                        Currency
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={payment?.buyerBankAccount?.currency}
                                        onChange={() => { }}
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-0 col-md-1 d-flex align-items-center justify-content-center">
                        <div className="vertical-divider" />
                    </div>
                    <div className="col-6 col-md-5">
                        <div className="form-group">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                                <div className="d-flex align-items-center">
                                <label  htmlFor="buyerBankAccounts" style={{ fontSize: 18, fontWeight: 600,margin:0 }}>
                                    Seller Bank Account
                                </label>
                                {payment?.sellerBankAccount?.id && <TooltipOverlay title={t("common.edit")} show={0} hide={0}>
                                    <div
                                        onClick={() => {
                                            const accountId =payment?.sellerBankAccount?.id
                                            setAddBankAccountVisible({ show: true, id: accountId?accountId.toString():null , type: "seller" })
                                        }
                                        }
                                        className="nav-link p-0 ml-3"
                                        style={{cursor:"pointer"}}
                                    >
                                        <FontAwesomeIcon icon={faEdit} className="mr-1" />
                                    </div>
                                </TooltipOverlay>
                                }
                                </div>
                                <button
                                    className="btn btn-sm btn-outline-primary justify-content-center align-items-center mb-0"
                                    onClick={() => setAddBankAccountVisible({ show: true, id: null, type: "seller" })}
                                >
                                    {t("item.add")}
                                </button>
                            </div>
                            <Select
                                // options={payment?.sellerBankAccounts ?? []}
                                options={payment?.sellerBankAccounts ?? []}
                                getOptionLabel={option =>option?.bank?.name +( option?.purchaseBankAccount?.bankAccountName ?`- ${option?.purchaseBankAccount?.bankAccountName}` : "")}
                                getOptionValue={option => option?.id}
                                styles={selectStyle}
                                value={payment?.sellerBankAccount}
                                onChange={(bankAccount) => {
                                    handleChange(
                                        null,
                                        "sellerBankAccount",
                                        bankAccount
                                    );
                                }}
                            />
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label htmlFor="recordDate">
                                        IBAN
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={payment?.sellerBankAccount?.purchaseBankAccount?.bankAccountId}
                                        onChange={() => { }}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label htmlFor="recordDate">
                                        Bank Name
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={payment?.sellerBankAccount?.bank?.name}
                                        onChange={() => { }}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label htmlFor="recordDate">
                                        Bank Account
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={payment?.sellerBankAccount?.purchaseBankAccount.bankAccountName}
                                        onChange={() => { }}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label htmlFor="recordDate">
                                        Currency
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={payment?.sellerBankAccount?.purchaseBankAccount.currency}
                                        onChange={() => { }}
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PaymentBankAccounts;
